module.exports = __webpack_public_path__ + "img/ge.4184bec3.svg";